<template>
  <div class="bg-gradient-to-b from-[#37BBED] to-[#0072BB] p-4">
    <div class="page_stretch_height flex flex-col items-center rounded-lg bg-white px-8 py-16">
      <img src="@/assets/images/avatar-sample.png" class="w-54 rounded-full sm:w-32" />
      <h4 class="mt-12 text-5xl text-primary-black">{{ store.user.role }}</h4>
      <button class="mt-12 flex w-2/3 max-w-xs items-center justify-between rounded-full border px-4 py-2 shadow-xl outline-none">
        <span class="text-sm font-medium text-primary-black">User Settings</span>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 011.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 01-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 01-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.107-1.204l-.527-.738a1.125 1.125 0 01.12-1.45l.773-.773a1.125 1.125 0 011.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      </button>
      <button @click="logout" class="mt-8 flex w-2/3 max-w-xs items-center justify-between rounded-full border px-4 py-2 shadow-xl outline-none">
        <span class="text-sm font-medium text-primary-black">Logout</span>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" />
        </svg>
      </button>
    </div>
  </div>
</template>
<script>
import { AppAuthStore } from "@/stores/app_auth_store";
import { SystemStore } from "@/stores/system_store";
export default {
  setup() {
    const store = AppAuthStore();
    const system_store = SystemStore();

    return { store, system_store };
  },

  created() {
    this.$api.call(this.store.user_profile()).then((response) => {
      console.log("Got devices response", response);
    });
  },

  mounted() {
    this.system_store.set_title("User Profile");
  },

  methods: {
    logout() {
      this.store.logout().then((response) => {
        // this.$router.push({name: 'root_path', replace: true});
        window.location.href = "/"; // Temp fix cookie problem. Cookie set in rails controller only work for first time.
      });
    },
  },
};
</script>
